import React from 'react'
import styled from 'styled-components'
import MoveflexStoreSlider from './moveflex-store-slider.component'
import Button from '../../../components/buttons/buttons.component'
import moveflexStoreImage from '../../../../assets/images/troque-seus-pontos/loja-muviflex.png'
import { history } from './../../../helpers/history'
import { breakpoints } from '../../../constants/breakpoints.constants'
import { routes } from '../../../constants'
import { StoreProductService } from '../../../services'

const StyledContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	margin-bottom: 15px;
	margin-top: 15px;

	@media (min-width: ${breakpoints.MOBILE}px) {
		padding: 20px 0px;
		background-color: #f3f3f3;
	}
`

const StyledImg = styled.img`
	width: 200px;
`

const buttonStyle = {
	marginTop: '30px'
}
class MoveflexStoreSection extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			items: [],
			hasMore: true,
			loadedPages: 0,
			isLoading: false
		}

		this.getData = this.getData.bind(this)
	}

	componentDidMount() {
		this.getData()
	}

	async getData() {
		const { loadedPages, hasMore, isLoading } = this.state

		if (!hasMore || isLoading) return

		const page = loadedPages + 1

		const params = {
			page,
			rowsPerPage: 10
		}

		this.setState({
			isLoading: true
		})

		const { items } = await StoreProductService.listLatest(params)

		if (items.length === 0) {
			this.setState({ hasMore: false })
		} else {
			this.setState({
				items: this.state.items.concat(items),
				loadedPages: loadedPages ? loadedPages + 1 : 2
			})
		}

		this.setState({
			isLoading: false
		})
	}

	render() {
		if (this.state.items.length === 0) {
			return null
		}

		return (
			<StyledContainer>
				<StyledImg src={moveflexStoreImage} alt={'Logo da loja muviflex'} />
				<MoveflexStoreSlider items={this.state.items} />
				<Button
					style={buttonStyle}
					primary
					type={'button'}
					onClick={() => history.push(routes.LOJA)}>
					Veja mais ofertas
				</Button>
			</StyledContainer>
		)
	}
}

export default MoveflexStoreSection
